/**
 * Global Error Handler for Frontend
 * Logs unhandled errors to backend system_logs for /admin/system-logs
 */

import axios from 'axios';
import { API_BASE_URL } from '../config/api';

class ErrorLogger {
  constructor() {
    this._lastErrorTime = 0;
    this._errorCount = 0;
    this.setupGlobalHandlers();
  }

  setupGlobalHandlers() {
    window.addEventListener('error', (event) => {
      this.logError({
        message: event.message,
        error_name: event.error?.name || 'Error',
        stack: event.error?.stack,
        url: window.location.href,
        line: event.lineno,
        column: event.colno
      });
    });

    window.addEventListener('unhandledrejection', (event) => {
      this.logError({
        message: event.reason?.message || 'Unhandled Promise Rejection',
        error_name: 'UnhandledRejection',
        stack: event.reason?.stack,
        url: window.location.href
      });
    });
  }

  logError(errorData) {
    // Throttle: max 3 errors per 10 seconds to avoid flooding
    const now = Date.now();
    if (now - this._lastErrorTime < 10000) {
      this._errorCount++;
      if (this._errorCount > 3) return;
    } else {
      this._errorCount = 0;
    }
    this._lastErrorTime = now;

    errorData.user_agent = navigator.userAgent;
    const payload = {
      level: 'error',
      category: 'frontend',
      message: errorData.message || 'Frontend Error',
      details: {
        error_name: errorData.error_name,
        stack: errorData.stack,
        component: errorData.component,
        componentStack: errorData.componentStack,
        url: errorData.url,
        line: errorData.line,
        column: errorData.column,
        user_agent: errorData.user_agent,
      },
      endpoint: errorData.url,
    };
    axios
      .post(`${API_BASE_URL}/api/logs/`, payload, { skipAuthRedirect: true })
      .catch(() => {});
    // Legacy analytics endpoint (same table)
    axios
      .post(`${API_BASE_URL}/api/analytics/log-frontend-error`, errorData, { skipAuthRedirect: true })
      .catch(() => {});
  }

  // Manual error logging for React components
  logManual(error, errorInfo, component) {
    this.logError({
      message: error.message,
      error_name: error.name,
      stack: error.stack,
      component: component,
      componentStack: errorInfo?.componentStack,
      url: window.location.href
    });
  }
}

// Create singleton instance
const errorLogger = new ErrorLogger();

export default errorLogger;
